import { MapDataService } from '@ui/shared/domain-map';
import { map, type Observable } from 'rxjs';
import { inject, Injectable } from '@angular/core';
import { PreventionListMeasureOrderingEnum, PreventionListService } from '@ui/shared/util-api';
import { toRequestQuery } from '@ui/shared/util-filter';
import { PreventionListItemModel } from '../../definitions/prevention-list-item.model';
import type { PreventionListFilter } from '../../types/prevention-list-filters';

@Injectable({ providedIn: 'root' })
export class PreventionListMeasureMapDataService extends MapDataService<PreventionListItemModel, PreventionListFilter> {
    protected _api = inject(PreventionListService);

    public getData$(filter: PreventionListFilter): Observable<Array<PreventionListItemModel>> {
        return this._api.getAllPreventionListMeasures({
            search: typeof filter.search === 'string' ? filter.search : null,
            categoryIds: toRequestQuery(filter.categories),
            ageGroupIds: toRequestQuery(filter.ageGroups),
            order: [PreventionListMeasureOrderingEnum.Title],
        })
            .pipe(map(response => response.data.map(dto => new PreventionListItemModel(dto))));
    }
}
